import { render } from "./LinkPreview.vue?vue&type=template&id=33c00c0c&scoped=true"
import script from "./LinkPreview.vue?vue&type=script&lang=js"
export * from "./LinkPreview.vue?vue&type=script&lang=js"

import "./LinkPreview.vue?vue&type=style&index=0&id=33c00c0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33c00c0c"],['__file',"src/components/modal/LinkPreview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33c00c0c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33c00c0c', __exports__)) {
    api.reload('33c00c0c', __exports__)
  }
  
  module.hot.accept("./LinkPreview.vue?vue&type=template&id=33c00c0c&scoped=true", () => {
    api.rerender('33c00c0c', render)
  })

}


export default __exports__